import Analytics16 from '@carbon/icons-react/es/analytics/16';
import EventsAlt16 from '@carbon/icons-react/es/events--alt/16';
import Home16 from '@carbon/icons-react/es/home/16';
import ListChecked16 from '@carbon/icons-react/es/list--checked/16';
import Meter16 from '@carbon/icons-react/es/meter/16';
import Notification16 from '@carbon/icons-react/es/notification/16';
import Settings16 from '@carbon/icons-react/es/settings/16';
import Task16 from '@carbon/icons-react/es/task/16';
import Template16 from '@carbon/icons-react/es/template/16';
import Timer16 from '@carbon/icons-react/es/timer/16';
import React from 'react';
import { UserType } from 'api/models';
import { useNotificationsDrawer } from 'components/organisms/notifications/drawer/hash-based-notifications';
import { RoutePaths } from 'constant';
import { useTranslate } from 'hooks/use-translation';
import { useUser } from 'hooks/use-user';
import { CommandGroup, CommandItem, CommandItemType } from '../types';

export const useGotoEntryForCmdk = (): CommandGroup => {
  const translate = useTranslate();
  const { user } = useUser();
  const [, show] = useNotificationsDrawer();

  return {
    groupId: 1000,
    tabbable: false,
    filterable: false,
    label: translate('go_to'),
    name: 'go_to',
    getCommandItems: async (filterText) => {
      const actions: CommandItem[] = [
        {
          label: translate('home.title'),
          icon: () => <Home16 />,
          meta: {
            type: CommandItemType.Navigate,
            link: RoutePaths.home,
          },
          name: 'go_to_home',
        },
        {
          label: translate('notifications'),
          icon: () => <Notification16 />,
          meta:
            user.userType === UserType.External
              ? {
                  type: CommandItemType.Navigate,
                  link: RoutePaths.notifications,
                }
              : {
                  type: CommandItemType.Callback,
                  callback: show,
                },

          name: 'go_to_home',
        },
        {
          label: translate('dashboard'),
          icon: () => <Meter16 />,
          meta: {
            type: CommandItemType.Navigate,
            link: RoutePaths.dashboard,
          },
          name: 'go_to_dashboards',
        },
        {
          label: translate('reports'),
          icon: () => <Analytics16 />,
          meta: {
            type: CommandItemType.Navigate,
            link: RoutePaths.reports,
          },
          name: 'go_to_reports',
        },
        {
          icon: () => <Task16 />,
          label: translate('breadcrumbs.projects'),
          meta: {
            type: CommandItemType.Navigate,
            link: RoutePaths.projects,
          },
          name: 'go_to_projects',
        },
        {
          label: translate('menu.label.tasks'),
          icon: () => <ListChecked16 />,
          meta: {
            type: CommandItemType.Navigate,
            link: RoutePaths.tasks,
          },
          name: 'go_to_all_tasks',
        },
        {
          label: translate('menu.label.resource_management'),
          icon: () => <EventsAlt16 />,
          meta: {
            type: CommandItemType.Navigate,
            link: RoutePaths.resourceManagement,
          },
          name: 'go_to_rm',
        },
        {
          label: translate('menu.label.timesheets'),
          icon: () => <Timer16 />,
          meta: {
            type: CommandItemType.Navigate,
            link: RoutePaths.timesheets,
          },
          name: 'go_to_timesheets',
        },
        {
          label: translate('menu.label.templates'),
          icon: () => <Template16 />,
          meta: {
            type: CommandItemType.Navigate,
            link: RoutePaths.templates,
          },
          name: 'go_to_templates',
        },
        {
          label: translate('menu.label.settings'),
          icon: () => <Settings16 />,
          meta: {
            type: CommandItemType.Navigate,
            link: RoutePaths.settings,
          },
          name: 'go_to_settings',
        },
      ];

      return filterText !== ''
        ? actions.filter((e) =>
            e.label
              .replaceAll(' ', '')
              .toLowerCase()
              .includes(filterText.replaceAll(' ', '').toLowerCase()),
          )
        : actions;
    },
  };
};
